<template lang="html">
  <div class="comment-button" id="comment" v-if="!showForm">
    <div class="comment-button-area">
      <button class="button is-info is-outlined" @click="open">
        Neuer Kommentar
      </button>
    </div>
  </div>
  <comment-item class="new-comment" id="comment" v-else>
    <form class="media-content" @submit.prevent="save">
      <div class="field">
        <p class="control">
          <textarea ref="comment" v-model="comment" class="textarea is-info" placeholder="Neuer Kommentar..."/>
        </p>
      </div>
      <div class="field">
        <p class="control">
          <button
            type="submit"
            class="button"
            :class="saving ? 'is-loading is-white' : saved ? 'is-successfull' : 'is-info is-outlined'"
            :disabled="saving"
          >Post comment</button>
        </p>
      </div>
    </form>
  </comment-item>
</template>

<script>
import CommentItem from './Comment.vue'

export default {
  props: {
    targetType: {type: String, required: true},
    targetId: {type: [Number, String], required: true},
    language: {type: String, default: window.__INIT_DATA.lang}
  },

  components: {
    CommentItem
  },

  data(){
    return {
      showForm: false,
      comment: '',
      saving: false,
      saved: false
    }
  },

  created(){
    this.$root.$on('openCommentForm', this.open)
  },

  methods: {
    open(){
      if(!this.$user.authenticated) return this.$user.showLoginDialog()
      this.showForm = true
      this.$nextTick(() => {
        this.$refs.comment.focus()
      })
    },

    save(){
      this.saving = true

      this.$api.createComment(this.comment, {target_id: this.targetId, target_type: this.targetType, language: this.language})
      .then(result => {
        if(result.id){
          this.saved = true
          this.saving = false
          this.comment = ''

          this.$emit('created', result)

          this.$timeout = setTimeout(() => {
            this.saved = false
          }, 1000)
        }else{
          throw new Error('commenting not successfull')
        }
      })
      .catch(e => {
        console.error(e)
        this.$toast.open({
          message: 'Beim Kommentieren ist ein Fehler aufgetreten!',
          type: 'is-danger'
        })
        this.saving = false
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/comment/Form.vue